export const stepInfo = {
  catering: {
    defaultStep: '시작하기',
    steps: [
      {
        title: '손님',
        list: ['시작하기', '주문하기', '결제하기', '적립하기', '픽업하기'],
      },
      {
        title: '점주님',
        list: ['', '', '', '조리하기', '호출하기'],
        isBetween: true,
        isArrow: [1, 2],
      },
    ],
    contents: [
      {
        step: '시작하기',
        subStep: [
          { name: '웰컴', desc: '제품을 홍보할 수 있는 시작 화면입니다.' },
          { name: '매장 / 포장', desc: '매장, 포장을 선택할 수 있습니다.' },
          { name: '컵 선택', desc: '매장 컵, 일회용 컵을 선택할 수 있습니다.' },
        ],
      },
      {
        step: '주문하기',
        subStep: [
          { name: '메뉴 선택', desc: '메뉴 선택이 가능합니다.' },
          { name: '옵션 선택', desc: '옵션 선택이 가능합니다.' },
          {
            name: '모바일 오더',
            desc: '우키키 서비스 중 하나로, 모바일로 상품 주문이 가능합니다.',
          },
        ],
      },
      {
        step: '결제하기',
        subStep: [
          {
            name: '결제 선택',
            desc: '카드, 현금, 모바일 페이, 선불카드, 기프티콘 등 다양한 결제를 지원합니다.',
          },
        ],
      },
      {
        step: '적립하기',
        subStep: [
          {
            name: '포인트 / 스탬프',
            desc: '키오스크에서 메뉴 주문 후 포인트 / 스탬프를 적립 및 사용할 수 있습니다.',
          },
        ],
      },
      {
        step: '픽업하기',
      },
      {
        step: '조리하기',
        subStep: [
          {
            name: '주방 프로그램',
            desc: '메뉴 제조 업무를 도와주는 포스 프로그램입니다.',
          },
          {
            name: '라벨 프린터',
            desc: '키오스크, 포스와 연동되어 라벨스티커를 제작, 출력해 상품에 부착 가능합니다.',
          },
        ],
      },
      {
        step: '호출하기',
        subStep: [
          {
            name: '모니터호출',
            desc: '모니터 호출이 가능합니다.',
          },
          {
            name: '알림톡',
            desc: '카카오 알림톡 호출이 가능합니다.',
          },
          { name: '진동벨', desc: '진동벨 호출이 가능합니다.' },
        ],
      },
    ],
  },
  unmanned: {
    defaultStep: '바코드 생성하기',
    steps: [
      {
        title: '손님',
        list: ['', '', '시작하기', '스캔하기', '결제하기'],
      },
      {
        title: '점주님',
        list: ['바코드 생성하기', '바코드 부착하기', '매장에 진열'],
      },
    ],
    contents: [
      {
        step: '바코드 생성하기',
        desc: '바코드를 생성합니다. (바코드가 있는 제품은 등록만으로 사용이 가능합니다.)',
      },
      { step: '바코드 부착하기', desc: '상품에 바코드를 부착합니다.' },
      { step: '매장에 진열', desc: '매장에 상품을 진열합니다.' },
      { step: '시작하기', desc: '시작 화면입니다.' },
      { step: '스캔하기', desc: '손님은 상품을 가져와 스캔합니다.' },
      {
        step: '결제하기',
        desc: '카드, 현금, 모바일 페이, 선불카드, 기프티콘 등 다양한 결제를 지원합니다.',
      },
    ],
  },
};
